import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Route } from "react-router-dom";
import styles from "./Protected.module.css";
import ScaleLoader from "react-spinners/ScaleLoader";
import RingLoader from "react-spinners/RingLoader";
import SquareLoader from "react-spinners/SquareLoader";

const Protected = ({ children, ...rest }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0();

  // If there's an error, display the error message.
  if (error) {
    return (
      <div className={styles.redirectCont}>
        <h1 className={styles.redHead}>
          User Authentication Error: {error.message}
        </h1>
        <SquareLoader
          color="#36d7b7"
          size={200}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  // If the authentication state is still loading, display the loading message.
  if (isLoading) {
    return (
      <div className={styles.loadingCont}>
        <h1 className={styles.lodHead}>Loading</h1>
        <RingLoader
          color="#36d7b7"
          size={80}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  // If the user is not authenticated, redirect them to Auth0 for login.
  if (!isAuthenticated) {
    loginWithRedirect();
    return (
      <div className={styles.redirectCont}>
        <h1 className={styles.redHead}>Redirecting</h1>
        <ScaleLoader
          color="#36d7b7"
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  // If the user is authenticated, render the children (i.e., the protected route's content).
  return <Route {...rest}>{children}</Route>;
};

export default Protected;
